import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NotificationService } from '../../services';
import { ServiceStore } from '../../stores';

interface BaseLayoutState {
    notificationService?: NotificationService;
}

interface BaseLayoutProps {
    ServiceStore?: ServiceStore;
}

@inject('ServiceStore') @observer
export class BaseLayout extends React.Component<BaseLayoutProps, BaseLayoutState> {
    constructor(props: BaseLayoutProps) {
        super(props);

        this.state = {notificationService: this.props.ServiceStore!.notificationService};
    }

    public render() {
        const { children } = this.props;

        const childrenWithProps = React.Children.map(children, (child: any) => {
            const routeChildren = React.Children.map(child.props.children, (routeChild) => {
                return React.cloneElement(routeChild as React.ReactElement<any>, { notificationService: this.state.notificationService });
            });

            return React.cloneElement(child as React.ReactElement<any>, { children: routeChildren });
        });

        return (
            <div>
                {childrenWithProps}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/BaseLayout.tsx